import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TireTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: TireTypeRow[];
  loading?: boolean;
};

const TireTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "tireTypeId",
        label: t("TIRE_TYPE.TABLE.SORT"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: TireTypeRow) => (
          <span className={styles.numberCell}>{row.tireTypeId}</span>
        ),
      },
      {
        id: "tireTypeName",
        label: t("TIRE_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        width: "calc((100% - 56px) / 2)",
        minWidth: "calc((100% - 56px) / 2)",
        format: (row: TireTypeRow) => (
          <span className={styles.textCell}>{row.tireTypeName ?? ""}</span>
        ),
      },
      {
        id: "tireCode",
        label: t("TIRE_TYPE.TABLE.CODE"),
        align: "right",
        width: "calc((100% - 56px) / 2)",
        minWidth: "calc((100% - 56px) / 2)",
        format: (row: TireTypeRow) => (
          <span className={styles.textCell}>{row.tireCode}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("TIRE_TYPE.EMPTY")}
      />
    </div>
  );
};

export default TireTypeTable;
